package fr.manyverse.app.domain.usecase.userconfig

import fr.manyverse.app.domain.repository.UserConfigRepository

class CheckTermsAcceptanceUseCase(private val repository: UserConfigRepository) {
    suspend operator fun invoke(userId: String): Result<Boolean> =
        repository.getUserConfig(userId).map { it?.hasAcceptedTerms ?: false }
}
